var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatVideoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#AC92ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42871 15.8571C8.42871 14.2569 8.42871 13.4568 8.74012 12.8457C9.01404 12.3081 9.45113 11.871 9.98874 11.5971C10.5999 11.2856 11.4 11.2856 13.0001 11.2856H16.7144C18.3146 11.2856 19.1147 11.2856 19.7258 11.5971C20.2634 11.871 20.7005 12.3081 20.9744 12.8457C21.2859 13.4568 21.2859 14.2569 21.2859 15.8571V18.1428C21.2859 19.7429 21.2859 20.543 20.9744 21.1542C20.7005 21.6918 20.2634 22.1289 19.7258 22.4028C19.1147 22.7142 18.3146 22.7142 16.7144 22.7142H13.0001C11.4 22.7142 10.5999 22.7142 9.98874 22.4028C9.45113 22.1289 9.01404 21.6918 8.74012 21.1542C8.42871 20.543 8.42871 19.7429 8.42871 18.1428V15.8571Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7144 15.2009C22.7144 15.0759 22.7144 15.0134 22.7331 14.9579C22.7497 14.9089 22.7767 14.864 22.8123 14.8264C22.8526 14.7839 22.9078 14.7546 23.0183 14.696L24.6078 13.8536C25.1615 13.5601 25.4384 13.4134 25.6642 13.4429C25.8614 13.4687 26.0389 13.5755 26.154 13.7377C26.2859 13.9234 26.2859 14.2367 26.2859 14.8634V19.1365C26.2859 19.7631 26.2859 20.0765 26.154 20.2622C26.0389 20.4243 25.8614 20.5311 25.6642 20.5569C25.4384 20.5865 25.1615 20.4397 24.6078 20.1463L23.0183 19.3038C22.9078 19.2453 22.8526 19.216 22.8123 19.1735C22.7767 19.1359 22.7497 19.091 22.7331 19.0419C22.7144 18.9864 22.7144 18.9239 22.7144 18.7989V15.2009Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatVideoIcon);
export default __webpack_public_path__ + "static/media/chat_video_icon.94e0e171e4842861f11cd7845bfca84d.svg";
export { ForwardRef as ReactComponent };